var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"UserBetChip",staticClass:"UserBetChip",class:("user-bet-chip-" + _vm.coinClass)},[_c('div',{staticClass:"box-select-coin"},[_c('span',[_vm._v(_vm._s(_vm.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }